import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function TypeCell({ row }) {
  const chat = row.original
  const { t } = useTranslation('TypeCell')

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">{t(chat.chat_type)}</div>
      </div>
    </div>
  )
}
